<template>
  <dp-container v-if="loading">
    <dp-loading />
  </dp-container>
  <dp-container v-else class="d-flex flex-column">
    <!-- Product Type Navbar -->
    <ProductTypeNavbar />
    <!-- Marketing Collection -->
    <div class="d-flex flex-column">
      <MarketingContent
        v-for="(content, index) in marketingCollection"
        :key="`marketing-collection-content-${index}`"
        :content="getMarketingContent(content)"
        :content-type="getMarketingContentType(content)"
        :style="{ order: content ? content.position : 0 }"
      />
    </div>
  </dp-container>
</template>

<script>
import { mapState } from 'vuex';
import { DpContainer, DpLoading } from '@docupet/component-library';
import ProductTypeNavbar from '@/components/ProductTypeNavbar';
import { MetaTagMixins } from '@/mixins/seo/metaTags';
import MarketingContent from '@/components/MarketingContent';

export default {
  name: 'WalletCards',
  components: {
    MarketingContent,
    ProductTypeNavbar,
    DpContainer,
    DpLoading,
  },
  mixins: [MetaTagMixins],
  props: {
    petId: {
      type: [String, Number],
      default: null,
      required: false,
    },
  },
  computed: {
    ...mapState({
      cityId: (state) => state.cityId,
      city: (state) => state.user.city,
      orderId: (state) => state.orderId,
      loading: (state) => state.walletCardProduct.loading || state.order.itemLoading,
      productGroups: (state) => state.walletCardProduct.groups,
      getLocale: (state) => state.locale,
      getBaseUrl: ({ baseUrl }) => baseUrl || window.BASE_URL || process.env.VUE_APP_BASE_URL,
    }),
    isWalletCardStoreForPetRoute() {
      return this.$route?.name === 'WalletCardStoreForPet';
    },
    marketingCollection() {
      return this.city?.walletCardLandingPageMarketingCollection?.marketingContentCollectionItems;
    },
  },
  created() {
    (async () => {
      if (!this.loading) {
        if (!this.productGroups || this.productGroups?.length === 0) {
          await this.$store.dispatch('walletCardProduct/fetchGroups', { cityId: this.city?.id || this.cityId });
        }
      }
      while (this.loading) await new Promise((resolve) => setTimeout(resolve, 1000));
    })().then(() => {
      if (this.isWalletCardStoreForPetRoute && this.petId) {
        // We only have 1 wallet card style
        const style = this.productGroups?.[0].productStyles?.[0];
        this.$store.dispatch('walletCardProduct/setStyle', style).then(() => {
          this.$router.push({
            name: 'WalletCardStyle',
            params: {
              petId: this.petId,
              styleId: style.id,
            },
            query: this.$router?.currentRoute?.query,
          });
        });
      }
    });
  },
  methods: {
    getMarketingContent(content) {
      return content?.marketingContent;
    },
    getMarketingContentType(content) {
      return this.getMarketingContent(content)?.type;
    },
  },
};
</script>

<style lang="scss" scoped></style>
